import { useEffect, useState } from 'react';
import {
  useFragment, graphql, fetchQuery, useRelayEnvironment,
} from 'react-relay';
import { nanoid } from 'nanoid';
import { isMobile } from 'react-device-detect';
import Emitter from '@/helpers/emitter.js';
import { useSearchZustandStore } from '@/helpers/searchctx.js';
import { lang } from '@/helpers/translate';
/*
liste var grapqhl change, call search
up to store, results listener will refresh IHM
*/
const fragmentSpaceSearch = graphql`
  fragment spaceEventWithParams on Query @argumentDefinitions (
    params: {type: "SearchSpaceParams"},
    disposition: {type:"[String]"},
    datesSelected: {type:"[JSONObject]"}
    lang: {type: "String"},
    riders: {type: "Int"},
    ) {
    results: searchSpaceByParams(params: $params) {
      resume
      spaces {
        id
        ...spaceResultSearchFragment @arguments(disposition: $disposition, datesSelected: $datesSelected, lang: $lang, riders: $riders)
      }
    }
  }
`;

const querySpacesSearch = graphql`
  query spaceEventWithParamsQuery ($params: SearchSpaceParams, $disposition: [String],$datesSelected: [JSONObject], $lang: String!, $riders: Int) {
    ...spaceEventWithParams @arguments(params: $params, disposition: $disposition, datesSelected: $datesSelected, lang: $lang, riders: $riders)
  }
`;

function SpaceEvent({ data, newFetch }) {
  // console.log('search/event/space - data rerender', !!data?.results);
  useEffect(() => {
    if (newFetch && data?.results?.spaces && data?.results?.resume) {
      if (data?.results?.spaces?.length) {
        // console.log('search/event/space - changed');
        useSearchZustandStore.setState({
          spacesData: data?.results,
          spacesDataDone: nanoid(),
        });
      } else {
        // console.log('search/event/space - EMPTY');
        useSearchZustandStore.setState({
          spacesData: [],
          spacesDataDone: nanoid(),
        });
      }
    }
  }, [newFetch]);

  return null;
}

function RefetchSpaceEvent({ data: dataData, ...props }) {
  const data = useFragment(fragmentSpaceSearch, dataData);

  return <SpaceEvent {...{ data }} {...props} />;
}

export default function SpaceEventContainer() {
  const [data, setData] = useState(null);
  const environment = useRelayEnvironment();
  const langCurrent = lang();

  const variables = useSearchZustandStore((state) => state.varGraphql);

  // console.log('search/event/space event rerender');

  useEffect(() => {
    if (Object.entries(variables).length) {
      // WEA-169 — premier varGraphql après un boot où la grille a adopté le résultat SSR :
      // on ne re-fetch pas (les 24 cartes serveur resteraient sinon remplacées par le
      // résultat bounds → re-clipping). Toute recherche suivante (drag, filtre, pagination)
      // passe normalement, le flag est consommé ici une seule fois.
      if (useSearchZustandStore.getState().skipNextSpacesFetch) {
        console.log('WEA169DEBUG space SKIP', JSON.stringify(variables).slice(0, 200));
        useSearchZustandStore.setState({ skipNextSpacesFetch: false });
        /*
          WEA-176 — le debounce de events/search.js ne garde que le DERNIER événement du
          boot : si l'init des filtres (runSearchFromFilter) arrive APRÈS celle de la carte
          (ordre machine-dépendant), c'est la branche qui ALLUME le squelette qui gagne,
          puis le skip ci-dessus avalait le fetch sans jamais l'éteindre — vignettes grises
          définitives par-dessus la grille pourtant adoptée. On éteint donc le signal ici :
          aucun fetch n'est en vol, l'état d'affichage doit refléter la grille du store.
        */
        setTimeout(() => { Emitter.emit('spaceloadingsearch', false); }, 0);
        return;
      }
      console.log('WEA169DEBUG space FETCH', JSON.stringify(variables).slice(0, 300));
      Emitter.emit('spaceloadingsearch', true);

      let newDatesSelected = {};
      if (variables?.dates?.values?.length) {
        newDatesSelected = { datesSelected: [...variables.dates.values] };
      }
      const ridersFromFilters = Array.isArray(variables?.riders) ? Number(variables.riders[0]) : Number(variables?.riders);
      const ridersArg = Number.isFinite(ridersFromFilters) && ridersFromFilters > 0 ? ridersFromFilters : null;
      fetchQuery(
        environment,
        querySpacesSearch,
        {
          params: {
            ...variables,
            category: 'production',
            lang: langCurrent,
          },
          disposition: variables?.disposition,
          lang: langCurrent,
          ...(ridersArg ? { riders: ridersArg } : {}),
          ...newDatesSelected,
        },
        {
          ...(!isMobile ? {
            force: true,
            transactionId: nanoid(),
          } : {
            poll: 60 * 1000,
          }),
        },
      ).subscribe({
        next: (dataRes) => {
          console.log('WEA169DEBUG space RES', (dataRes?.results?.spaces || dataRes?.spaces?.results?.spaces || '??')?.length ?? JSON.stringify(dataRes).slice(0, 120));
          setData({ spaces: { ...dataRes }, newFetch: nanoid() });
          setTimeout(() => { Emitter.emit('spaceloadingsearch', false); }, 0);
        },
        error: (error1) => {
          console.log('error1', error1);
          setTimeout(() => { Emitter.emit('spaceloadingsearch', false); }, 0);
        },
      });
    }
  }, [variables]);

  return (
    <>
      <RefetchSpaceEvent {...{ data: data?.spaces || null, newFetch: data?.newFetch }} />
    </>
  );
}
